import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import Navbar from '../components/Navbar';
import '../components/Navbar.css';

function ContributionsPage() {
  document.title = 'Florida Elections - Search Contributions';

  const [searchParams, setSearchParams] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    business: '',
    occupation: '',
    type: '',
    city: '',
    state: '',
    zip: ''
  });

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchParams(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSearched(false);

    try {
      const query = new URLSearchParams(searchParams).toString();
      const response = await fetch(`/api/contributions/search?${query}`);
      if (response.ok) {
        const data = await response.json();
        setResults(data.results || []);
        console.log('Search results:', data);
      } else {
        console.error('Search failed');
        setResults([]);
      }
    } catch (error) {
      console.error('Error:', error);
      setResults([]);
    } finally {
      setLoading(false);
      setSearched(true);
    }
  };

  const columns = [
    {
      name: 'Date',
      selector: row => row.date,
      sortable: true,
      width: '120px',
    },
    {
      name: 'Amount',
      selector: row => row.amount,
      sortable: true,
      format: row => `$${row.amount ? row.amount.toLocaleString() : 'N/A'}`,
      width: '100px',
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
      width: '200px',
      cell: row => row.voterId ? (
        <a 
          href={`https://www.flelections.com/donor/${row.voterId}`} 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ color: '#2563eb', textDecoration: 'none' }}
          onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
          onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
        >
          {row.name}
        </a>
      ) : row.name
    },
    {
      name: 'City',
      selector: row => row.city,
      sortable: true,
      width: '150px',
    },
    {
      name: 'State',
      selector: row => row.state,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Zip',
      selector: row => row.zip,
      sortable: true,
      width: '100px',
    },
    {
      name: 'Occupation',
      selector: row => row.occupation,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Type',
      selector: row => row.type,
      sortable: true,
      width: '120px',
    },
  ];

  return (
    <div style={{ background: '#ffffff', minHeight: '100vh', color: '#000' }}>
      <Navbar />

      <main style={{ maxWidth: '1200px', margin: '18px auto', padding: '24px' }}>
        <section style={{ padding: '32px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.1)', marginBottom: '24px', backgroundColor: '#ffffff', border: '1px solid #e5e7eb' }}>
          <div style={{ marginBottom: '24px' }}>
            <h2 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: '600', color: '#111827' }}>Search Contributions</h2>
            <p style={{ margin: '0', color: '#6b7280', fontSize: '14px' }}>Filter contributions by contributor details, location, and other criteria</p>
          </div>

          <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '24px' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="firstName" style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>First Name</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={searchParams.firstName}
                onChange={handleInputChange}
                placeholder="First name"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  color: '#111827',
                  backgroundColor: '#ffffff',
                  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                  outline: 'none'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#3b82f6';
                  e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="middleName" style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>Middle Name</label>
              <input
                type="text"
                id="middleName"
                name="middleName"
                value={searchParams.middleName}
                onChange={handleInputChange}
                placeholder="Middle name"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  color: '#111827',
                  backgroundColor: '#ffffff',
                  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                  outline: 'none'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#3b82f6';
                  e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="lastName" style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={searchParams.lastName}
                onChange={handleInputChange}
                placeholder="Last name"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  color: '#111827',
                  backgroundColor: '#ffffff',
                  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                  outline: 'none'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#3b82f6';
                  e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="business" style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>Business</label>
              <input
                type="text"
                id="business"
                name="business"
                value={searchParams.business}
                onChange={handleInputChange}
                placeholder="Business name"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  color: '#111827',
                  backgroundColor: '#ffffff',
                  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                  outline: 'none'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#3b82f6';
                  e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="occupation" style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>Occupation</label>
              <input
                type="text"
                id="occupation"
                name="occupation"
                value={searchParams.occupation}
                onChange={handleInputChange}
                placeholder="e.g. Attorney, Teacher"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  color: '#111827',
                  backgroundColor: '#ffffff',
                  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                  outline: 'none'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#3b82f6';
                  e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="type" style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>Contributor Type</label>
              <input
                type="text"
                id="type"
                name="type"
                value={searchParams.type}
                onChange={handleInputChange}
                placeholder="B, I, C, etc."
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  color: '#111827',
                  backgroundColor: '#ffffff',
                  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                  outline: 'none'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#3b82f6';
                  e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="city" style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>City</label>
              <input
                type="text"
                id="city"
                name="city"
                value={searchParams.city}
                onChange={handleInputChange}
                placeholder="City name"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  color: '#111827',
                  backgroundColor: '#ffffff',
                  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                  outline: 'none'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#3b82f6';
                  e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="state" style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>State</label>
              <input
                type="text"
                id="state"
                name="state"
                value={searchParams.state}
                onChange={handleInputChange}
                placeholder="State name"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  color: '#111827',
                  backgroundColor: '#ffffff',
                  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                  outline: 'none'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#3b82f6';
                  e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="zip" style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>Zip Code</label>
              <input
                type="text"
                id="zip"
                name="zip"
                value={searchParams.zip}
                onChange={handleInputChange}
                placeholder="Zip code"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  color: '#111827',
                  backgroundColor: '#ffffff',
                  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                  outline: 'none'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#3b82f6';
                  e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <div style={{ gridColumn: 'span 2', display: 'flex', alignItems: 'end', justifyContent: 'center', marginTop: '8px' }}>
              <button
                type="submit"
                style={{
                  padding: '12px 32px',
                  backgroundColor: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
                  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                  minWidth: '120px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#2563eb';
                  e.target.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#3b82f6';
                  e.target.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                }}
              >
                Search
              </button>
            </div>
          </form>
        </section>

        {searched && (
          <section style={{ padding: '20px', borderRadius: 12, boxShadow: '0 1px 6px rgba(16,24,40,0.04)' }}>
            <h3>Search Results ({results.length} found)</h3>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <DataTable
                columns={columns}
                data={results}
                pagination
                paginationPerPage={50}
                paginationRowsPerPageOptions={[25, 50, 100]}
                highlightOnHover
                responsive
              />
            )}
          </section>
        )}
      </main>
    </div>
  );
}

export default ContributionsPage;